import { useState, useEffect } from 'react';
import { User } from '../types';
import { 
  subscribeToAuthChanges, 
  signIn as firebaseSignIn, 
  signUp as firebaseSignUp,
  signOutUser 
} from '../services/firebase';

export function useFirebaseAuth() {
  const [user, setUser] = useState<User | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const unsubscribe = subscribeToAuthChanges((firebaseUser) => {
      setUser(firebaseUser);
      setIsLoading(false);
    });

    return unsubscribe;
  }, []);

  const signIn = async (email: string, password: string) => {
    try {
      setError(null);
      await firebaseSignIn(email, password);
    } catch (err: any) {
      setError(err.message);
      throw err;
    }
  };

  const signUp = async (email: string, password: string, name: string) => {
    try {
      setError(null);
      await firebaseSignUp(email, password, name);
    } catch (err: any) {
      setError(err.message);
      throw err;
    }
  };

  const signOut = async () => {
    try {
      setError(null);
      await signOutUser();
    } catch (err: any) {
      setError(err.message);
      throw err;
    }
  };

  return {
    user,
    isLoading,
    error,
    signIn,
    signUp,
    signOut
  };
}